import React from 'react';
import { ArrowRight, Linkedin, Instagram, TrendingUp, FileText, Brain, Activity, BarChart3, Users, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import MetaTags from '../components/SEO/MetaTags';
import SilkCover from '../components/ui/SilkCover';
import { pageConfigs } from '../utils/seo';

export default function SocialMedia() {

  // Blog posts data - 12 posts (Why Notation featured first)
  const blogPosts = [
    {
      id: 12,
      title: "Why Notation? We Are More Than Just an AI Scribe",
      subtitle: "Real utility for clinicians. Notes that are auditable, compliant, and secure.",
      backgroundImage: "/blog/Booth1.png",
      icon: <Brain className="h-6 w-6 text-gray-600" />,
      date: "2/12/2026",
      author: "Fownd Team",
      action: "Read Blog",
      link: "/blogs/why-notation-more-than-ai-scribe",
      featured: true
    },
    {
      id: 11,
      title: "Differences Between AI Scribe and Real-Time Documentation Tools",
      subtitle: "Deciding Factors, Misconceptions, and More",
      backgroundImage: "/blog/blog-11.png",
      icon: <Brain className="h-6 w-6 text-gray-600" />,
      date: "1/21/2026",
      author: "Fownd Team",
      action: "Read Blog",
      link: "/blogs/ai-scribe-vs-realtime-documentation",
      featured: false
    },
    {
      id: 10,
      title: "The Future of Documentation: AI That Follows the Visit, Not the Form",
      subtitle: "Discover how AI-powered documentation can follow your PT sessions naturally instead of forcing care into rigid forms",
      backgroundImage: "/blog/blog-10.png",
      icon: <Brain className="h-6 w-6 text-gray-600" />,
      date: "12/16/2025",
      author: "Christina Rama",
      action: "Read Blog",
      link: "/blogs/ai-documentation-follows-visit-not-form",
      featured: false
    },
    {
      id: 9,
      title: "Top 5 AI Note-Taking Tools for PT Clinics (and Where Fownd Fits In)",
      subtitle: "Compare the leading AI documentation tools for physical therapy clinics and discover how Fownd Notation stands out",
      backgroundImage: "/blog/default.jpg",
      icon: <Brain className="h-6 w-6 text-gray-600" />,
      date: "10/16/2025",
      author: "Fownd Team",
      action: "Read Blog",
      link: "/blogs/top-5-ai-note-taking-tools-pt-clinics"
    },
    {
      id: 8,
      title: "AI for SOAP Notes: Everything a PT Should Know in 2025",
      subtitle: "A comprehensive guide to AI documentation tools and what physical therapists need to know",
      backgroundImage: "/blog/default.jpg",
      icon: <Brain className="h-6 w-6 text-gray-600" />,
      date: "9/15/2025",
      author: "Fownd Team",
      action: "Read Blog",
      link: "/blogs/ai-soap-notes-pt-guide-2025"
    },
    {
      id: 7,
      title: "Why Not PT First? Rethinking MSK care at the front door",
      subtitle: "Exploring the expanding role of physical therapists as first-contact providers",
      backgroundImage: "/blog/blog-6.png",
      icon: <Users className="h-6 w-6 text-gray-600" />,
      date: "8/15/2025",
      author: "Christina Rama PT, DPT",
      action: "Read Blog",
      link: "/blogs/why-not-pt-first"
    },
    {
      id: 6,
      title: "Proving Outcomes Is the Future of PT — Are We Ready?",
      subtitle: "How outcome tracking is reshaping physical therapy and what it means for providers",
      backgroundImage: "/blog/blog-5.png",
      icon: <BarChart3 className="h-6 w-6 text-gray-600" />,
      date: "7/30/2025",
      author: "Christina Rama PT, DPT",
      action: "Read Blog",
      link: "/blogs/proving-outcomes-future-pt"
    },
    {
      id: 5,
      title: "What If the Session Wrote the Note?",
      subtitle: "Rethinking Documentation Timing in Physical Therapy",
      backgroundImage: "/blog/blog-4.png",
      icon: <FileText className="h-6 w-6 text-gray-600" />,
      date: "7/18/2025",
      author: "Christina Rama PT, DPT",
      action: "Read Blog",
      link: "/blogs/session-wrote-note"
    },
    {
      id: 4,
      title: "The Rise of AI Scribes in Healthcare: Why Notation Is Poised to Lead Physical Therapy Into the Future",
      subtitle: "Purpose-built for physical therapy, Notation functions like your personal PT-GPT: a domain-specialized, multimodal AI assistant",
      backgroundImage: "/blog/default.jpg",
      icon: <Brain className="h-6 w-6 text-gray-600" />,
      date: "7/12/2025",
      author: "Rohan Sai Nalla",
      action: "Read Blog",
      link: "/blogs/ai-scribes-healthcare-notation-physical-therapy-future"
    },
    {
      id: 3,
      title: "AI in Healthcare: Tackling Bias for Better Care",
      subtitle: "Building Fair and Inclusive Clinical Tools",
      backgroundImage: "/blog/blog-3.png",
      icon: <Brain className="h-6 w-6 text-gray-600" />,
      date: "6/6/2025",
      author: "Christina Rama PT, DPT",
      action: "Read Blog",
      link: "/blogs/ai-healthcare-bias"
    },
    {
      id: 2,
      title: "Fownd's Vision For Advocacy and Higher Reimbursement",
      subtitle: "Empowering PTs Through Data and Policy",
      backgroundImage: "/blog/blog-2.png",
      icon: <TrendingUp className="h-6 w-6 text-gray-600" />,
      date: "6/6/2025",
      author: "Christina Rama PT, DPT",
      action: "Read Blog",
      link: "/blogs/advocacy-reimbursement"
    },
    {
      id: 1,
      title: "The Power of Documentation in Physical Therapy",
      subtitle: "Reimagining Patient Progress & Clinic Efficiency",
      backgroundImage: "/blog/blog-1.png",
      icon: <Activity className="h-6 w-6 text-gray-600" />,
      date: "6/6/2025",
      author: "Christina Rama PT, DPT",
      action: "Read Blog",
      link: "/blogs/documentation-physical-therapy"
    }
  ];


  return (
    <>
      <MetaTags
        title={pageConfigs.blogs.title}
        description={pageConfigs.blogs.description}
        keywords={pageConfigs.blogs.keywords}
        canonical={pageConfigs.blogs.canonical}
      />
      <div className="mx-auto">
      {/* Blogs Section Title */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#1e3d3b] via-[#2a5a56] to-[#1e3d3b]">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-[#1e3d3b]/20 to-[#1e3d3b]/40"></div>
        <div
          className="relative px-6 py-24 md:py-32 lg:py-32"

        >
          <div className="max-w-2xl mx-auto text-center">
            <h4 className="font-medium mb-2" style={{ color: '#619dd2' }}>Our Latest Updates</h4>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight font-productSans">
              Latest Blogs</h1>
            <p className="text-emerald-100 text-lg">Discover insights, updates, and stories about physical therapy and healthcare innovation</p>
          </div>
        </div>
      </section>

      {/* Blog Cards Section */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {/* All blog cards with equal height */}
          {blogPosts.map((post) => {
            const isFeatured = (post as { featured?: boolean }).featured;
            return (
            <Link key={post.id} to={post.link} className="block group">
              <div className={`rounded-lg overflow-hidden shadow-md h-full hover:shadow-lg transition-all duration-300 cursor-pointer group-hover:scale-[1.02] flex flex-col relative ${isFeatured ? 'ring-2 ring-amber-400 ring-offset-2' : ''}`}>
                {isFeatured && (
                  <div className="absolute top-3 right-3 z-20 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-400/95 text-amber-900 text-xs font-semibold shadow-lg">
                    <Sparkles className="w-4 h-4" />
                    Featured
                  </div>
                )}
                <div
                  className="h-48 flex items-center justify-center group-hover:opacity-90 transition-opacity duration-300 relative"
                  style={{
                    backgroundImage: `url(${post.backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  {/* Blur overlay */}
                  <div className="absolute inset-0 backdrop-blur-sm bg-black/20"></div>
                  {/* Icon */}
                  <div className="bg-white p-3 rounded-full group-hover:scale-110 transition-transform duration-300 relative z-10">
                    {post.icon}
                  </div>
                </div>
                <div className="p-6 bg-white flex-1 flex flex-col">
                  <h3 className={`font-productSans font-bold text-xl mb-2 group-hover:text-gray-700 transition-colors duration-300 ${isFeatured ? 'text-[#1F3D3B]' : ''}`}>
                    {post.title}
                  </h3>
                  <h4 className="text-gray-600 mb-3">{post.subtitle}</h4>
                  <p className="text-gray-500 text-sm mb-3">By {post.author}</p>
                  <div className="flex justify-between items-center mt-auto">
                    <span className="text-gray-500">{post.date}</span>
                    <span className="inline-flex items-center text-gray-800 group-hover:text-gray-600 font-medium transition-colors duration-300">
                      {post.action} <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          );
          })}
        </div>

        {/* Divider */}
        <div className="flex justify-center mb-16">
          <div className="w-1/2 h-px bg-gray-300"></div>
        </div>

        {/* Social Media Section */}
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold font-productSans">Social Media</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {/* LinkedIn Card */}
          <div className="rounded-2xl overflow-hidden shadow-md bg-white">
            <SilkCover base="#429CCB" className="h-48 flex items-center justify-center">
              <div className="relative z-10 w-12 h-12 bg-white/25 backdrop-blur-sm rounded-full flex items-center justify-center">
                <Linkedin className="h-6 w-6 text-white" />
              </div>
            </SilkCover>
            <div className="p-6">
              <h3 className="font-productSans font-bold text-xl mb-1">LinkedIn Posts</h3>
              <h4 className="text-gray-600 mb-3">Industry Insights</h4>
              <p className="text-gray-500 text-sm mb-4">
                Follow our LinkedIn for the latest updates, industry insights and company announcements.
              </p>
              <div className="flex justify-end items-center">
                <a
                  href="https://www.linkedin.com/company/fownd-inc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black font-semibold hover:text-gray-700 visited:text-black transition-colors flex items-center gap-1"
                >
                  View Posts <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          {/* Instagram Card */}
          <div className="rounded-2xl overflow-hidden shadow-md bg-white">
            <SilkCover base="#f2eacb" className="h-48 flex items-center justify-center">
              <div className="relative z-10 w-12 h-12 bg-white/40 backdrop-blur-sm rounded-full flex items-center justify-center">
                <Instagram className="h-6 w-6 text-[#1f3d3b]" />
              </div>
            </SilkCover>
            <div className="p-6">
              <h3 className="font-productSans font-bold text-xl mb-1">Instagram Posts</h3>
              <h4 className="text-gray-600 mb-3">Visual Stories</h4>
              <p className="text-gray-500 text-sm mb-4">
                Check out our Instagram for visual stories, team highlights and behind-the-scenes content.
              </p>
              <div className="flex justify-end items-center">
                <Link
                  to="/instagram"
                  className="text-black font-semibold hover:text-gray-700 visited:text-black transition-colors flex items-center gap-1"
                >
                  View Posts <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 border border-gray-800 rounded-full text-gray-800 hover:bg-[#439CCB] hover:border-[#439CCB] hover:text-white transition-colors"
          >
            Back to Home <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </div>
    </div >
    </>
  );
}
